/** Anteprima inline PDF/immagini di un allegato email (blob dal download). */
import { useEffect, useState } from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from '@floraltech/ui';
import { emailFetch, type EmailAllegato } from '../lib/api';

interface Props {
  messaggioId: string;
  allegato: EmailAllegato | null;
  onClose: () => void;
}

export function anteprimaSupportata(contentType: string | null): boolean {
  if (!contentType) return false;
  return contentType.startsWith('image/') || contentType === 'application/pdf';
}

export default function AllegatoAnteprimaDialog({ messaggioId, allegato, onClose }: Props) {
  const [url, setUrl] = useState<string | null>(null);
  const [errore, setErrore] = useState<string | null>(null);

  useEffect(() => {
    if (!allegato) return;
    let objectUrl: string | null = null;
    (async () => {
      const res = await emailFetch(
        `/messaggi/${messaggioId}/allegati/${allegato.id}/download`
      );
      if (!res.ok) {
        setErrore('Anteprima non disponibile');
        return;
      }
      const blob = await res.blob();
      objectUrl = URL.createObjectURL(
        new Blob([blob], { type: allegato.content_type ?? 'application/octet-stream' })
      );
      setUrl(objectUrl);
    })();
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      setUrl(null);
      setErrore(null);
    };
  }, [allegato, messaggioId]);

  return (
    <Dialog open={!!allegato} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-5xl">
        <DialogHeader>
          <DialogTitle className="truncate">{allegato?.filename ?? 'Anteprima'}</DialogTitle>
        </DialogHeader>
        {errore && <p className="text-sm text-muted-foreground">{errore}</p>}
        {url && allegato?.content_type === 'application/pdf' && (
          <iframe src={url} title="Anteprima PDF" className="h-[75vh] w-full rounded border" />
        )}
        {url && allegato?.content_type?.startsWith('image/') && (
          <img src={url} alt={allegato.filename ?? ''} className="max-h-[75vh] w-auto mx-auto" />
        )}
      </DialogContent>
    </Dialog>
  );
}
